import { APITypesV1 } from "@cur8/api-client";

/**
 * Norav reports `assignmentStatus` from a live device RPC whose lock can
 * expire mid-recording, so it can return `CanAssign` while the visit's scan
 * is already `Inprogress` or `Finished`. Treat any started scan as a
 * re-assign state to avoid showing "Assign to Norav" once recording has begun.
 */
export function isReassignNoravEcg(
  assignmentStatus: APITypesV1.DeviceAssignmentStatus | undefined,
  ecgScanState: APITypesV1.ImmutableScanState | undefined
): boolean {
  if (
    assignmentStatus === APITypesV1.DeviceAssignmentStatus.AssignedToMember ||
    assignmentStatus === APITypesV1.DeviceAssignmentStatus.OtherMemberAssigned
  ) {
    return true;
  }
  return (
    ecgScanState === APITypesV1.ImmutableScanState.Inprogress ||
    ecgScanState === APITypesV1.ImmutableScanState.Finished
  );
}
